import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'isPrimaryTimelineItem',
	standalone: true
})
export class IsPrimaryTimelineItemPipe implements PipeTransform {
	/**
	 * Finds the index of an item that should be opened by default
	 * within the timeline based on a given property key.
	 *
	 * @param items{any[]}
	 * @param key{string}
	 *
	 * @returns number
	 */
	public transform(items: any[], key: string): number {
		if (!Array.isArray(items) || items.length === 0 || !key) {
			return 0;
		}

		const index = items.findIndex((item: any) => item[key]);

		return index > 0 ? index : 0;
	}
}
